import { motion } from "framer-motion";
import { BadgeCheck, Flame, Lock, ShieldCheck, Coins } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const STATS = [
  { icon: Coins, value: "1,000,000,000", label: "Total Supply" },
  { icon: BadgeCheck, value: "0%", label: "Buy / Sell Tax" },
  { icon: Flame, value: "100%", label: "LP Burned" },
  { icon: Lock, value: "Revoked", label: "Mint Authority" },
  { icon: ShieldCheck, value: "Renounced", label: "Contract Ownership" },
];

export default function TokenomicsBlueprint() {
  return (
    <section className="relative bg-[#0A0C10] py-28 sm:py-36" data-testid="tokenomics-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: EASE }}
          className="text-center"
        >
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#E5A93C]">
            06 / The Blueprint
          </p>
          <h2 className="mx-auto mt-5 max-w-2xl font-display text-2xl font-extrabold uppercase leading-tight tracking-tight sm:text-3xl lg:text-4xl">
            Certified <span className="text-[#E5A93C]">degen-proof.</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.85, ease: EASE, delay: 0.1 }}
          className="guilloche mt-14 rounded-3xl p-[1px]"
        >
          <div className="relative rounded-3xl border border-[rgba(229,169,60,0.4)] bg-[#0E1015] px-6 py-12 sm:px-12">
            {["left-4 top-4", "right-4 top-4", "bottom-4 left-4", "bottom-4 right-4"].map((pos) => (
              <span key={pos} className={`absolute ${pos} font-display text-lg text-[rgba(229,169,60,0.5)]`}>
                ◆
              </span>
            ))}
            <p className="text-center font-mono2 text-[10px] uppercase tracking-[0.35em] text-[#64748B]">
              Official certificate of meme authenticity
            </p>
            <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-4">
              {STATS.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, ease: EASE, delay: 0.15 + i * 0.07 }}
                  className="text-center"
                  data-testid={`tokenomics-stat-${s.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full border border-[rgba(229,169,60,0.4)] bg-[#07080A]">
                    <s.icon className="h-5 w-5 text-[#F6C85F]" />
                  </div>
                  <p className="mt-4 font-display text-lg font-black tracking-tight text-[#F8FAFC] sm:text-xl">
                    {s.value}
                  </p>
                  <p className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.22em] text-[#64748B]">
                    {s.label}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
